import React from "react";
import GraphFilled from "../../../Components/Icons/GraphFilled";
import GraphBlank from "../../../Components/Icons/GraphBlank";

/**
 * GraphIcon
 *
 * Props:
 * - isSelected: boolean -> when true shows GraphFilled, else GraphBlank
 * - style can be passed in for sizing
 */
export default function GraphIcon({ isSelected, ...rest }) {
    if (isSelected) {
        return <GraphFilled {...rest} />;
    }
    return <GraphBlank {...rest} />;
}